import {
  FIELD_LABEL_CREATED,
  FIELD_LABEL_UPDATED,
  FIELD_LABEL_FILE_SIZE,
  FIELD_LABEL_FILE_TYPE,
  FIELD_LABEL_FILE_ID,
} from "../../../constants/fileManagement.constants";
import {
  formatDate,
  formatFileSize,
} from "../../../utils/fileManagement.utils";
import type { FileDetailsGeneralProps } from "../../../types/fileManagement.types";

const FileDetailsGeneral = ({
  createdAt,
  updatedAt,
  sizeInBytes,
  fileType,
  fileId,
}: FileDetailsGeneralProps) => {
  return (
    <div className="grid grid-cols-2 gap-x-8 gap-y-4 pb-[30px] pt-2.5">
      <div className="flex flex-col gap-1">
        <span className="text-sub-base font-medium text-analytics-gray dark:text-analytics-gray-dk">
          {FIELD_LABEL_CREATED}
        </span>
        <span className="text-base font-normal text-verba-indigo dark:text-verba-indigo-dk">
          {formatDate(createdAt)}
        </span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-sub-base font-medium text-analytics-gray dark:text-analytics-gray-dk">
          {FIELD_LABEL_UPDATED}
        </span>
        <span className="text-base font-normal text-verba-indigo dark:text-verba-indigo-dk">
          {formatDate(updatedAt)}
        </span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-sub-base font-medium text-analytics-gray dark:text-analytics-gray-dk">
          {FIELD_LABEL_FILE_SIZE}
        </span>
        <span className="text-base font-normal text-verba-indigo dark:text-verba-indigo-dk">
          {formatFileSize(sizeInBytes)}
        </span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-sub-base font-medium text-analytics-gray dark:text-analytics-gray-dk">
          {FIELD_LABEL_FILE_TYPE}
        </span>
        <span className="text-base font-normal text-verba-indigo dark:text-verba-indigo-dk">
          {fileType}
        </span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-sub-base font-medium text-analytics-gray dark:text-analytics-gray-dk">
          {FIELD_LABEL_FILE_ID}
        </span>
        <span className="text-base font-normal text-verba-indigo dark:text-verba-indigo-dk">
          {fileId}
        </span>
      </div>
    </div>
  );
};

export default FileDetailsGeneral;
